module.exports = __webpack_public_path__ + "img/personnage_choix_6.7ba54605.png";